import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINES = [
  "Warming the top notes…",
  "Blending the heart…",
  "Settling into the base…",
  "Distilling your signature…",
];

export default function Distilling() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % LINES.length), 1400);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      className="min-h-screen w-full flex flex-col items-center justify-center px-6"
      data-testid="loading-section"
    >
      <motion.div
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        className="w-14 h-14 border border-border relative"
      >
        <span
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at center, hsl(var(--gold) / 0.35) 0%, transparent 60%)",
          }}
        />
      </motion.div>
      <div className="mt-10 label-caps text-foreground/60">
        The atelier at work
      </div>
      <motion.h2
        key={i}
        initial={{ opacity: 0, y: 6, filter: "blur(6px)" }}
        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
        className="font-serif italic text-3xl sm:text-5xl mt-4 text-foreground text-center max-w-xl"
      >
        {LINES[i]}
      </motion.h2>
    </section>
  );
}
